<template>
  <Header />
  <div :class="$style.container">
    <div :class="$style.desctop">
      <div :class="$style.cards">
        <div :class="$style.column">
          <div
            :class="[
              $style.card,
              { [$style.active]: activeTab.category === card.id },
              { [$style.pointer]: card?.activities?.length === 1 },
            ]"
            v-for="card in groups.filter((i) => i.column_number == 1)"
            :key="card.id"
            @click="setCategory(card)"
          >
            <div :class="$style.image">
              <img :src="card.image?.url" alt="" />
            </div>
            <div :class="$style.content">
              <div :class="$style.title">{{ card.name }}</div>
              <div v-if="card?.activities?.length > 1" :class="$style.list">
                <div
                  v-for="item in card.activities"
                  :key="item.id"
                  @click="setTab(card.id, item.name, item.id)"
                  :class="[
                    $style.item,
                    { [$style.active]: activeTab.item === item.name },
                  ]"
                >
                  <div :class="$style.radio">
                    <div :class="$style.decor"></div>
                  </div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="$style.column">
          <div
            :class="[
              $style.card,
              { [$style.active]: activeTab.category === card.id },
              { [$style.pointer]: card?.activities?.length === 1 },
            ]"
            v-for="card in groups.filter((i) => i.column_number == 2)"
            :key="card.id"
            @click="setCategory(card)"
          >
            <div :class="$style.image">
              <img :src="card.image?.url" alt="" />
            </div>
            <div :class="$style.content">
              <div :class="$style.title">{{ card.name }}</div>
              <div v-if="card?.activities?.length > 1" :class="$style.list">
                <div
                  v-for="item in card.activities"
                  :key="item.id"
                  @click="setTab(card.id, item.name, item.id)"
                  :class="[
                    $style.item,
                    { [$style.active]: activeTab.item === item.name },
                  ]"
                >
                  <div :class="$style.radio">
                    <div :class="$style.decor"></div>
                  </div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :class="[$style.column, $style.hidden]">
          <div
            :class="[
              $style.card,
              { [$style.active]: activeTab.category === card.id },
              { [$style.pointer]: card?.activities?.length === 1 },
            ]"
            v-for="card in groups.filter((i) => i.column_number == 3)"
            :key="card.id"
            @click="setCategory(card)"
          >
            <div :class="$style.image">
              <img :src="card.image?.url" alt="" />
            </div>
            <div :class="$style.content">
              <div :class="$style.title">{{ card.name }}</div>
              <div v-if="card?.activities?.length > 1" :class="$style.list">
                <div
                  v-for="item in card.activities"
                  :key="item.id"
                  @click="setTab(card.id, item.name, item.id)"
                  :class="[
                    $style.item,
                    { [$style.active]: activeTab.item === item.name },
                  ]"
                >
                  <div :class="$style.radio">
                    <div :class="$style.decor"></div>
                  </div>
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="[$style.cards, $style.tablet]">
        <div
          :class="[
            $style.card,
            { [$style.active]: activeTab.category === card.id },
          ]"
          v-for="card in groups.filter((i) => i.column_number == 3)"
          :key="card.id"
        >
          <div :class="$style.image">
            <img :src="card.image?.url" alt="" />
          </div>
          <div :class="$style.content">
            <div :class="$style.title">{{ card.name }}</div>
            <div :class="$style.list">
              <div
                v-for="item in card.activities"
                :key="item.id"
                @click="setTab(card.id, item.name, item.id)"
                :class="[
                  $style.item,
                  { [$style.active]: activeTab.item === item.name },
                ]"
              >
                <div :class="$style.radio">
                  <div :class="$style.decor"></div>
                </div>
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="activeTab.item" :class="$style.chosen">
      <div :class="[$style.item, $style.active]">
        <div :class="$style.radio">
          <div :class="$style.decor"></div>
        </div>
        {{ activeTab.item }}
      </div>
    </div>

    <div :class="$style.mobile">
      <div
        v-for="card in groups"
        :key="card.id"
        @click="openActivity(card)"
        :class="[
          $style.item,
          { [$style.active]: activeTab.category === card.id },
        ]"
      >
        <div :class="$style.image">
          <img :src="card.image?.url" alt="" />
        </div>
        <div :class="$style.name">
          {{ card.name }}
        </div>
      </div>
    </div>
    <div :class="$style.icons">
      <!-- <div :class="$style.icon" @click="openModal('info')">
        <img src="/icons/ticker/info.svg" alt="" />
        <div :class="$style.text">инструкция</div>
      </div> -->
      <div
        v-if="activeTab.activityId"
        :class="$style.icon"
        @click="openModal('comment')"
      >
        <img src="/icons/ticker/comment.svg" alt="" />
        <div :class="$style.text">оставьте комментарий</div>
      </div>
      <div
        v-if="activeTab.activityId"
        :class="[$style.icon, { [$style.active]: isFailure }]"
        @click="openModal('')"
      >
        <img v-if="!isFailure" src="/icons/ticker/warning.svg" alt="" />
        <img v-else src="/icons/ticker/warning-active.svg" alt="" />
      </div>
    </div>
  </div>
  <InfoModal v-if="iconsModals.info" />
  <CommentModal v-if="iconsModals.comment" :id="activeTab.activityId" />
  <ActivityModal
    v-if="iconsModals.activity"
    :modalData="modalData"
    :activeTab="activeTab"
    @setTab="({ category, item, id }) => setTab(category, item, id)"
  />
</template>

<script>
import { mapState } from "vuex";
import Repository from "@/repository";
import Header from "@/components/common/Header.vue";
import CommentModal from "@/components/ticker/modals/CommentModal.vue";
import InfoModal from "@/components/ticker/modals/InfoModal.vue";
import ActivityModal from "@/components/ticker/modals/ActivityModal.vue";
import getLastSupervision from "@/mixins/getLastSupervision";
export default {
  mixins: [getLastSupervision],
  components: {
    Header,
    CommentModal,
    InfoModal,
    ActivityModal,
  },
  data() {
    return {
      isFailure: false,
      icons: [
        {
          icon: "/icons/ticker/info.svg",
          activeIcon: "/icons/ticker/info.svg",
          text: "инструкция",
          modal: "info",
        },
        {
          icon: "/icons/ticker/comment.svg",
          activeIcon: "/icons/ticker/comment.svg",
          text: "оставьте комментарий",
          modal: "comment",
        },
        {
          icon: "/icons/ticker/warning.svg",
          activeIcon: "/icons/ticker/warning-active.svg",
        },
      ],
      groups: [],
      activeTab: {
        category: "",
        item: "",
        id: "",
        activityId: "",
      },
      modalData: {},
      supervision: {},
    };
  },
  async mounted() {
    await this.fetchData();
    await this.getSupervision();
    this.setLastTab();
  },
  methods: {
    async fetchData() {
      this.$store.commit("setLoadersCount", "+");
      const { value, error } = await Repository.Layouts.get({
        supervision_id: this.$route.params.id,
      });
      this.$store.commit("setLoadersCount", "-");
      if (value) {
        this.groups = value[0]?.activity_groups || [];
      }
    },
    async getSupervision() {
      this.$store.commit("setLoadersCount", "+");
      const { value, error } = await Repository.Supervision.getOne({
        id: this.$route.params.id,
      });
      this.$store.commit("setLoadersCount", "-");
      if (value) {
        this.supervision = value;
        this.$store.commit("setSupervision", value);
        const targetDate = new Date(value.start_date);
        const currentDate = new Date();
        const diffInSeconds = Math.round(
          Math.abs(currentDate - targetDate) / 1000
        );
        this.$store.commit("setTimer", diffInSeconds);
        if (this.timer === null) {
          this.$store.commit("startTimer");
        }
      }
    },
    async setTab(category, item, id) {
      if (this.activeTab.item !== item) {
        const { value, error } = await Repository.Supervision.Activity.create({
          id: this.$route.params.id,
          activity: id,
        });
        this.activeTab.category = category;
        this.activeTab.item = item;
        this.activeTab.id = id;
        this.activeTab.activityId = value.id;
      }
    },
    async setCategory(category) {
      if (category.activities.length === 1) {
        if (this.activeTab.item !== category.activities[0].name) {
          const { value, error } = await Repository.Supervision.Activity.create(
            {
              id: this.$route.params.id,
              activity: category.activities[0].id,
            }
          );
          this.activeTab.category = category.id;
          this.activeTab.item = category.activities[0].name;
          this.activeTab.id = category.activities[0].id;
          this.activeTab.activityId = value.id;
        }
      }
    },
    setLastTab() {
      if (this.lastSupervision && this.lastSupervision?.analytics?.length) {
        const lastActivity =
          this.lastSupervision.analytics[
            this.lastSupervision.analytics.length - 1
          ];

        this.activeTab.item = lastActivity.activity.name;
        this.activeTab.activityId = lastActivity.id;
        this.isFailure = Boolean(lastActivity.failure);
        if (this.isFailure && lastActivity.failure.end_date) {
          this.isFailure = false;
        }
        const id = lastActivity.activity.id;

        this.groups.forEach((group) => {
          group.activities.forEach((activity) => {
            if (activity.id == id) {
              this.activeTab.category = group.id;
              this.activeTab.id = activity.id;
            }
          });
        });
        console.log(this.activeTab);
      }
    },
    openActivity(category) {
      if (category.activities.length === 1) {
        this.setCategory(category);
      } else {
        this.$store.commit("setIconsModals", {
          modal: "activity",
          value: true,
        });
        this.modalData = category;
      }
    },
    async openModal(modal) {
      if (!modal) {
        console.log(this.activeTab);

        if (this.activeTab.id) {
          this.isFailure = !this.isFailure;
          if (this.isFailure) {
            await Repository.Supervision.Activity.startFailure({
              id: this.$route.params.id,
              activity: this.activeTab.id,
            });
          } else {
            await Repository.Supervision.Activity.finishFailure({
              id: this.$route.params.id,
              activity: this.activeTab.id,
            });
          }
        }
      } else {
        if (modal === "comment" && !this.activeTab.activityId) {
          return;
        }
        this.$store.commit("setIconsModals", {
          modal: modal,
          value: true,
        });
      }
    },
  },
  computed: {
    ...mapState({
      iconsModals: (state) => state.modals.iconsModals,
      timer: (state) => state.timer.timer,
      seconds: (state) => state.timer.seconds,
      lastSupervision: (state) => state.auth.lastSupervision,
    }),
  },
  watch: {
    lastSupervision() {
      this.setLastTab();
    },
  },
};
</script>

<style lang="scss" module>
@keyframes active {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: #321fd53d;
    box-shadow: 0 0 1.125rem 0 rgba(56, 110, 210, 1);
  }
  100% {
    background-color: transparent;
  }
}
@keyframes faulure {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: #321fd53d;
    box-shadow: 0 0 1.125rem 0 red;
  }
  100% {
    background-color: transparent;
  }
}
.container {
  @include container;
  position: relative;
  .desctop {
    .tablet {
      display: none;
    }
    @include custom(1150) {
      margin: 1rem 0 0 0;
      .tablet {
        display: grid;
        margin: 1rem 0 0 0;
      }
    }
    @include custom(700) {
      display: none;
    }
  }
  .chosen {
    display: none;
    @include custom(700) {
      margin: 1.5rem 0 1.5rem 0;
      display: block;
      .item {
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        display: flex;

        align-items: start;
        gap: 0.625rem;
        margin: 0 0 0.5rem 0;
        &:last-child {
          margin: 0;
        }
        &.active {
          position: relative;
          left: -0.45rem;
          font-weight: 700;
          .radio {
            position: relative;
            top: -0.125rem;
            left: 0.125rem;
            display: flex;
            align-items: center;
            justify-content: center;
            flex: 0 0 1.5rem;
            width: 1.5rem;
            height: 1.5rem;
            background-color: #321fd53d;
            border-radius: 50%;
            border: none;
            .decor {
              width: 1rem;
              height: 1rem;
              background-color: #386ed2;
              border-radius: 50%;
              border: 1px solid #386ed2;
            }
          }
        }
        .radio {
          position: relative;
          top: 0.125rem;
          flex: 0 0 1rem;
          width: 1rem;
          height: 1rem;
          background-color: $bg-white;
          border-radius: 50%;
          border: 1px solid $black;
        }
      }
    }
  }
  .mobile {
    display: none;
    @include custom(700) {
      margin: 1rem 0 0 0;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      @include custom(380) {
        gap: 0.75rem;
      }
      @include custom(374) {
        gap: 0.5rem;
      }
    }
    .item {
      padding: 1rem;
      border-radius: 1.5rem;
      background-color: $bg-white;
      @include custom(430) {
        padding: 0.5rem;
      }
      .image {
        height: 5rem;
        img {
          border-radius: 1rem 1rem 0 0;
          height: 100%;
          width: 100%;
          object-fit: cover;
          @include custom(430) {
            border-radius: 0.75rem 0.75rem 0 0;
          }
        }
      }
      .name {
        margin: -1rem 0 0 0;
        background: rgba(248, 250, 250, 0.08);
        backdrop-filter: blur(1.5rem);
        padding: 1rem;
        border-radius: 1rem;
        text-align: center;
        min-height: 4.75rem;
        @include custom(430) {
          padding: 0.5rem;
        }
      }
      &.active {
        box-shadow: 0 0 1.125rem 0 rgba(56, 110, 210, 1);
      }
    }
  }
  .cards {
    display: grid;
    align-items: start;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 1rem;
    @include custom(1150) {
      grid-template-columns: 1fr 1fr;
      .column {
        &.hidden {
          display: none;
        }
      }
    }
    .card {
      overflow: hidden;
      position: relative;
      padding: 1rem 1rem 0.75rem 1rem;
      background-color: $bg-white;
      border-radius: 2rem;
      margin: 0 0 1rem 0;
      &:last-child {
        margin: 0;
      }
      &.active {
        box-shadow: 0 0 1.125rem 0 rgba(56, 110, 210, 1);
      }
      &.pointer {
        cursor: pointer;
      }
      .image {
        max-width: 100%;
        height: 10.75rem;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 1.25rem;
        }
      }
      .content {
        margin: -2rem 0 0 0;
        padding: 1rem;
        border-radius: 1rem;
        background: rgba(248, 250, 250, 0.08);
        backdrop-filter: blur(1.5rem);
        @include custom(1440) {
          padding: 1rem 0;
        }
        .title {
          text-align: center;
          font-size: 1.5rem;
          font-weight: 700;
        }
        .list {
          padding-top: 1rem;
          .item {
            transition: all 0.3s ease-in-out;
            cursor: pointer;
            display: flex;

            align-items: start;
            gap: 0.625rem;
            margin: 0 0 0.5rem 0;
            &:last-child {
              margin: 0;
            }
            &.active {
              position: relative;
              left: -0.45rem;
              font-weight: 700;
              .radio {
                position: relative;
                top: -0.125rem;
                left: 0.125rem;
                display: flex;
                align-items: center;
                justify-content: center;
                flex: 0 0 1.5rem;
                width: 1.5rem;
                height: 1.5rem;
                background-color: #321fd53d;
                animation: active 2s infinite;
                border-radius: 50%;
                border: none;
                .decor {
                  width: 1rem;
                  height: 1rem;
                  background-color: #386ed2;
                  border-radius: 50%;
                  border: 1px solid #386ed2;
                }
              }
            }
            .radio {
              position: relative;
              top: 0.125rem;
              flex: 0 0 1rem;
              width: 1rem;
              height: 1rem;
              background-color: $bg-white;
              border-radius: 50%;
              border: 1px solid $black;
            }
          }
        }
      }
    }
  }
  .icons {
    position: fixed;
    bottom: 2rem;
    right: 1.5rem;
    align-items: flex-end;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    @include custom(1150) {
      right: 1rem;
      bottom: 1rem;
      gap: 1rem;
    }
    .icon {
      display: flex;
      align-items: center;
      cursor: pointer;
      img {
        width: 3rem;
        height: 3rem;
      }
      &:hover {
        .text {
          width: 100%;
          visibility: visible;
          opacity: 1;
          padding: 0 2.25rem;
          margin: 0 0 0 1rem;
        }
      }
      &.notHover {
        .text {
          visibility: hidden;
          white-space: nowrap;
          opacity: 0;
        }
      }
      &.active {
        img {
          animation: faulure 2s infinite;
          border-radius: 50%;
        }
      }
    }
    .text {
      border-radius: 2.5rem;
      background-color: $black;
      display: flex;
      align-items: center;
      height: 3rem;
      font-weight: 700;
      font-size: 16px;
      color: $t-white;
      width: 0;
      visibility: hidden;
      white-space: nowrap;
      opacity: 0;
      transition: all 0.2s linear;
      @include custom(1024) {
        display: none;
      }
    }
  }
}
</style>
